import { combineReducers } from "redux";
import loginReducer from "./login.reducer"
import stockReducer from "./stock.reducer";
import historyReducer from "./history.reducer"

export default combineReducers({
    loginReducer,
    stockReducer,
    historyReducer
})